<template>
  <div>
    <donut v-if="dataReady" :series="series" :labels="seriesLabels" :chartOptions="chartOptions"></donut>
  </div>
</template>
<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import { axiosMixin } from '../../mixin/axiosMixin';
import donut from './donut.vue'
export default {
  mixins: [axiosMixin],
  components: {
    StatisticsCardLine,
    donut
  },
  data() {
    return {
      series: [],
      dataReady: false,
      seriesLabels: [],
      seriesColors: [],
      total: 2,
      chartOptions: {
        legend: {
          show: true,
          position: 'bottom',
          fontSize: '14px',
          fontFamily: 'Montserrat'
        },
        colors: [],
        dataLabels: {
          enabled: true,
          formatter(val, opts) {
            return opts.w.config.series[opts.seriesIndex].toLocaleString();
          }
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  fontSize: '2rem',
                  fontFamily: 'Montserrat'
                },
                value: {
                  fontSize: '1rem',
                  fontFamily: 'Montserrat',
                  formatter(val) {
                    // eslint-disable-next-line radix
                    return val
                  }
                },
                total: {
                  show: true,
                  fontSize: '1.5rem',
                  label: 'Total',
                  formatter(w) {
                    return w.globals.seriesTotals.reduce((a, b) => {
                      return a + b
                    }, 0).toLocaleString();
                  }
                }
              }
            }
          }
        },
        labels: [],
        responsive: [
          {
            breakpoint: 992,
            options: {
              chart: {
                height: 280
              },
              legend: {
                position: 'bottom'
              }
            }
          },
          {
            breakpoint: 576,
            options: {
              chart: {
                height: 120
              },
              plotOptions: {
                pie: {
                  donut: {
                    labels: {
                      show: true,
                      name: {
                        fontSize: '1.5rem'
                      },
                      value: {
                        fontSize: '1rem'
                      },
                      total: {
                        fontSize: '1.5rem'
                      }
                    }
                  }
                }
              },
              legend: {
                show: false
              }
            }
          }
        ]
      }
    };
  },
  methods: {
    startLoading() {
      this.$vs.loading({
        container: '#container',
        scale: 0.6
      });
    },
    stopLoading() {
      this.$vs.loading.close('#container > .con-vs-loading');
    },
    getData() {
      this.aronPost(
        'getGrDashboard',
        {
        },
        '',
        ''
      )
        .then(response => {
          if (response.data.status) {
            this.series = response.data.series;
            this.seriesLabels = response.data.seriesLabels;
            this.seriesColors = response.data.seriesColors;
            this.chartOptions.colors = response.data.seriesColors;
            this.chartOptions.labels = response.data.seriesLabels;

            this.total = response.data.total;
            this.dataReady = true;
          } else {
            this.errorAlert('Error', response.data.error)
          }

          // this.stopLoading("loader");
        })
        .catch(error => {
          console.log('error:', error)
          this.stopLoading('loader')
        })
    }

  },
  props: {
    dasbhboardData: {
      type: Object,
      default: {}
    }
  },
  mounted() {
    this.dataReady = false;
    console.log('dasbhboardData:', this.dasbhboardData);
    this.series = this.dasbhboardData.series;
    this.seriesLabels = this.dasbhboardData.seriesLabels;
    this.seriesColors = this.dasbhboardData.seriesColors;
    this.chartOptions.colors = this.dasbhboardData.seriesColors;
    this.chartOptions.labels = this.dasbhboardData.seriesLabels;
    this.total = this.dasbhboardData.total;
    this.dataReady = true;
    //  this.getData()
    this.dataReady = true;
  },
  created() {

  }
};
</script>
